import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { noop, numberOrBlank } from 'Helpers/PropTypes';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import NormalizedInput from '..';

import './index.css';

class Text extends Component {
  constructor(props) {
    super(props);

    this.state = {
      negative: props.value && props.value < 0,
    };

    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { props, state } = this;
    const propKeys = Object.keys(nextProps);
    const stateKeys = Object.keys(nextState);
    stateKeys.splice(stateKeys.indexOf('negative'), 1);
    for (let i = 0; i < propKeys.length; i += 1) {
      if (props[propKeys[i]] !== nextProps[propKeys[i]]) {
        return true;
      }
    }
    for (let i = 0; i < stateKeys.length; i += 1) {
      if (state[stateKeys[i]] !== nextState[stateKeys[i]]) {
        return true;
      }
    }
    return false;
  }

  handleBlur() {
    const {
      max, min, name, onBlur, onChange, value,
    } = this.props;
    const newValue = value === '' ? '' : Math.max(Math.min(value, max), min);
    if (value !== newValue) onChange(name, newValue);
    onBlur();
  }

  handleChange({ floatValue, value: stringValue }) {
    const { name } = this.props;
    const { onChange } = this.props;
    const { negative } = this.state;
    let value;
    if (floatValue === undefined) {
      value = '';
      this.setState({ negative: false });
    } else {
      value = (negative ? -1 : 1) * floatValue;
      if (value === 0) {
        if (stringValue.substring(0, 1) === '-') {
          this.setState({ negative: !negative });
        }
      } else {
        this.setState({ negative: value < 0 });
      }
    }
    const { max } = this.props;
    if (value > 1000000000) {
      displayErrorMessage(
        new Error('Too many dollars'),
        "You've exceeded the maximum amount of $1,000,000,000",
      );
      onChange(name, '1000000000');
    } else if (value > max) {
      displayErrorMessage(
        new Error('Too many dollars'),
        `You've exceeded the maximum amount of $${max}.`,
      );
      onChange(name, max);
    } else {
      onChange(name, value);
    }
  }

  render() {
    const {
      handleBlur,
      handleChange,
      readOnly,
      state: { negative },
    } = this;
    const {
      className, decimalScale, min, value, name, onChange, ...rest
    } = this.props;
    let newValue = value;
    if (value !== '' && value < 0) {
      newValue = -value;
    }

    return (
      <NormalizedInput readOnly={readOnly}>
        <NumberFormat
          {...rest}
          className={`Currency ${className}`}
          allowNegative={min < 0}
          decimalScale={decimalScale}
          name={name}
          onBlur={handleBlur}
          prefix={negative ? '[$' : '$'}
          suffix={negative ? ']' : ''}
          thousandSeparator=","
          onValueChange={handleChange}
          value={newValue}
        />
      </NormalizedInput>
    );
  }
}

Text.propTypes = {
  className: PropTypes.string,
  decimalScale: PropTypes.number,
  max: PropTypes.number,
  min: PropTypes.number,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  value: numberOrBlank,
  readOnly: PropTypes.bool,
};

Text.defaultProps = {
  className: '',
  decimalScale: 0,
  max: 1000000000,
  min: -1000000000,
  onBlur: noop,
  onChange: noop,
  value: '',
  readOnly: false,
};

export default Text;
